import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import IconHeader from "../../images/logo.png";
import "./style.scss";
import axios from "axios";
import AppConstants from "../../AppConstants";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRememberTrue, setIsRememberTrue] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid email address"
      )
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
    rememberMe: Yup.boolean()
  });

  const formik = useFormik({
    validateOnChange: true,
    validateOnBlur: false,
    initialValues: {
      email: "",
      password: "",
      rememberMe: false
    },
    validationSchema,
    onSubmit: async (values) => {
      if (isRememberTrue) {
        localStorage.setItem("userCred", JSON.stringify(values));
      } else {
        localStorage.removeItem("userCred");
      }

      setLoading(true);

      try {
        const response = await axios.post(
          AppConstants.ADMIN_LOGIN_API,
          {
            email: values.email,
            password: values.password
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );

        if (response.status == 200) {
          toast.success("OTP sent to email", {
            position: toast.POSITION.TOP_RIGHT
          });

          navigate("/otp-authentication", {
            state: { email: response.data.email }
          });
        }
      } catch (error: any) {
        const message =
          error?.response?.data?.error ||
          error?.message ||
          "Login failed. Please try again.";

        toast.error(message, {
          position: toast.POSITION.TOP_RIGHT
        });
      } finally {
        setLoading(false);
      }
    }
  });

  useEffect(() => {
    const userData = localStorage.getItem("userCred");
    if (userData) {
      formik.setValues(JSON.parse(userData));
      setIsRememberTrue(true);
    }
  }, []);

  return (
    <section className="dashboard credential-page">
      <Container fluid>
        <Row className="justify-content-md-center">
          <Col xl={4} lg={6} sm={12}>
            <Card className="px-5 pt-4 pb-5" style={{ borderRadius: "16px" }}>
              <figure className="text-center">
                <img src={IconHeader} alt="logo" width={250} />
                <h1>Login</h1>
              </figure>
              <Form onSubmit={formik.handleSubmit} noValidate>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label className="mb-1">
                    Email Address<sup>*</sup>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="p-3"
                    isInvalid={formik.touched.email && !!formik.errors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.email}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group
                  className="mb-3 position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Label className="mb-1">
                    Password<sup>*</sup>
                  </Form.Label>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="password p-3"
                    isInvalid={
                      formik.touched.password && !!formik.errors.password
                    }
                  />
                  <i
                    onClick={togglePasswordVisibility}
                    className="password-icon"
                    style={{
                      position: "absolute",
                      right: "31px",
                      top: "44px",
                      cursor: "pointer"
                    }}
                  >
                    {showPassword ? <BsEyeSlash /> : <BsEye />}
                  </i>
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.password}
                  </Form.Control.Feedback>
                </Form.Group>

                <Button
                  variant="primary"
                  className="mt-2 border-0 text-white font-16 w-100 py-3 gilroy-semibold"
                  type="submit"
                  size="lg"
                  disabled={formik.isSubmitting || loading}
                >
                  {loading ? "Logging in..." : "Sign in"}
                </Button>
              </Form>
            </Card>
          </Col>
        </Row>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
        />
      </Container>
    </section>
  );
};

export default Login;
